import React from 'react';
import { BRAND_NAME } from '../../config/brand';
import { cardTheme } from '../../styles/cardTheme';

const HOME_ITEMS = [
  {
    src: '/img/home-items/1.svg',
    title: 'منهج شامل',
    description: 'باقات مميزة للمراجعات بتساعدك تتقن المنهج في مدة قصيرة',
  },
  {
    src: '/img/home-items/2.svg',
    title: 'جودة عالية',
    description: 'محتوى تعليمي بجودة عالية تليق بتميز الطالب الأزهري',
  },
  {
    src: '/img/home-items/3.svg',
    title: 'مدرسين خبراء',
    description: 'مدرسين بخبرة أكثر من ١٠ سنوات في تدريس طلاب الثانوية الأزهرية',
  },
  {
    src: '/img/home-items/4.svg',
    title: 'تعلم في أي وقت',
    description: 'شوف الدروس وقت ما تحب — من موبايلك أو لابتوبك في أي مكان',
  },
  {
    src: '/img/home-items/5.svg',
    title: 'مراجعات وامتحانات',
    description: 'أسئلة ومراجعات شاملة تجهزك للامتحانات بثقة',
  },
  {
    src: '/img/home-items/6.svg',
    title: 'دعم مستمر',
    description: 'فريق دعم ومجتمع طلابي يساعدك طول رحلتك التعليمية',
  },
];

const WhyChooseBanner: React.FC = () => (
  <section id="why-choose-section" className="py-12 md:py-16 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-8 sm:mb-10">
        <span className={`inline-flex items-center gap-2 ${cardTheme.badgeGold} mb-4`}>
          لماذا نحن؟
        </span>
        <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 ${cardTheme.title}`}>
          ليه {BRAND_NAME} أفضل اختيار ليك؟
        </h2>
        <p className={`text-sm sm:text-base max-w-2xl mx-auto ${cardTheme.subtitle}`}>
          منصة متكاملة بتركّز على احتياجات طالب الثانوية الأزهرية — من الشرح للمراجعة للدعم
        </p>
      </div>

      <div className="flex flex-row items-start justify-center flex-wrap gap-y-6">
        {HOME_ITEMS.map((item, index) => (
          <div
            key={item.src}
            className="w-1/2 sm:w-1/3 lg:w-1/6 flex flex-col items-center text-center p-2 md:p-4 lg:p-5"
          >
            <img
              src={item.src}
              alt={item.title}
              className="scale-animation h-32 sm:h-36 md:h-40 lg:h-44 w-auto mb-3 sm:mb-4"
              style={{ animationDelay: `${index * 0.2}s` }}
              loading="lazy"
            />
            <h3 className={`text-sm sm:text-base font-bold mb-1.5 sm:mb-2 ${cardTheme.title}`}>
              {item.title}
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed max-w-[180px]">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseBanner;
